import makeStyles from '@mui/styles/makeStyles';
import { SIDEBAR_STEP_MAX_WIDTH } from '../../../helpers/constants';

export const createClasses = makeStyles(theme => ({
  container: {
    maxWidth: SIDEBAR_STEP_MAX_WIDTH
  },
  subtitle: {
    color: theme.palette.primary[400],
    marginBottom: theme.spacing(4)
  },
  // Figma 555:2457 - section title is H4 (16/21 medium), 32px below the
  // attention box, 24px above the cards; cards are 12px apart with 12px/16px
  // padding and the 16px radio sits flush with the card's content edge.
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '21px',
    marginTop: theme.spacing(4)
  },
  optionsContainer: {
    marginTop: theme.spacing(3)
  },
  optionRow: {
    marginBottom: theme.spacing(1.5),
    '&:last-child': { marginBottom: 0 },
    '& > div': {
      height: 'auto',
      padding: theme.spacing(1.5, 2),
      '& > label': {
        alignItems: 'flex-start',
        margin: 0,
        padding: 0,
        '& .MuiRadio-root': {
          padding: 0,
          margin: '2px 12px 0 0'
        }
      }
    }
  }
}));
